var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-combobox',{attrs:{"auto-select-first":"","label":"Observatory","items":_vm.items},model:{value:(_vm.Observatory),callback:function ($$v) {_vm.Observatory=$$v},expression:"Observatory"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }